import React from 'react'
import Pagetitle from '../components/pagetitle/Pagetitle'
import Servicedetail from '../components/servicedetail/Servicedetail'
import wordpressimg from './../Images/WordPress-9e5d2a96e3e09df68cc3e54a4e764ebf.png'
export default function Wordpress() {
  const servicetechnologies = ['JavaScript' , 'HTML' , 'Git' , 'CSS' , 'SQL' ]
  return (
    <div>
      <Pagetitle pagename="Wordpress" parentpage="Home" />
      <Servicedetail serviceimg={wordpressimg} servicesabout="WordPress is a Simplest but most powerful and popular tool. You can easily manage your site, even if you dont have any IT experience" technologies={servicetechnologies}/>
    </div>
  )
}
